import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';

export default function StaffAuthCallback() {
  const navigate = useNavigate();
  const { staffLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          toast.error('Authentication failed - no session ID');
          navigate('/staff/login');
          return;
        }

        const sessionId = sessionIdMatch[1];
        
        // Exchange session_id for user data
        await staffLogin(sessionId);
        
        // Clear the hash and redirect
        window.history.replaceState(null, '', '/staff/dashboard');
        toast.success('Welcome to FTASM Staff Portal!');
        navigate('/staff/dashboard', { replace: true });
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Authentication failed');
        navigate('/staff/login');
      }
    };

    processAuth();
  }, []);

  return (
    <div className="min-h-screen bg-deep-charcoal flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sage mx-auto mb-4"></div>
        <p className="font-body text-white/60">Authenticating...</p>
      </div>
    </div>
  );
}
